export class BatchIngestionPipelineMetricsRangeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ingestionPipelineIds",
            "baseName": "ingestionPipelineIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "series",
            "baseName": "series",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "startTs",
            "baseName": "startTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "endTs",
            "baseName": "endTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "stepSeconds",
            "baseName": "stepSeconds",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchIngestionPipelineMetricsRangeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
